module.exports = __webpack_public_path__ + "static/img/200240.251c259b.png";